"use client"

import { Button } from "@/components/ui/button"
import { Link } from "react-router-dom"
import { useState } from "react"
import { Menu, X } from "lucide-react"

export const Header = () => {
  const [mobileMenuOpen, setMobileMenuOpen] = useState(false)

  return (
    <header className="fixed top-0 left-0 right-0 z-50 w-full bg-gray-900/95 backdrop-blur-sm border-b border-gray-800">
      <div className="w-full max-w-full mx-auto px-4 sm:px-6 lg:px-8">
        <div className="flex items-center justify-between h-16">
          <div className="flex-shrink-0">
            <Link to="/" className="block">
              <img
                src="/lovable-uploads/0d001ec0-9306-40f4-b5bf-f2887ff1fc1a.png"
                alt="Stewie Trader"
                className="h-10 sm:h-12 w-auto object-contain"
              />
            </Link>
          </div>

          {/* Desktop navigation */}
          <div className="hidden sm:flex items-center space-x-8">
            <Link to="/docs" className="text-blue-300 hover:text-white font-medium transition-colors">
              Docs
            </Link>
            <Link to="/investor" className="text-blue-300 hover:text-white font-medium transition-colors">
              Investor Portal
            </Link>
            <Link to="/auth" onClick={() => console.log("Desktop login button clicked")}>
              <Button variant="outline" className="rounded-md border-gray-700 bg-blue-900/30 text-blue-300 hover:bg-blue-800/50 hover:text-white font-medium">
                Login
              </Button>
            </Link>
          </div>

          {/* Mobile menu button */}
          <div className="sm:hidden">
            <Button
              variant="ghost"
              className="text-gray-300 hover:text-white"
              onClick={() => setMobileMenuOpen(!mobileMenuOpen)}
              aria-label={mobileMenuOpen ? "Close menu" : "Open menu"}
            >
              {mobileMenuOpen ? <X size={24} /> : <Menu size={24} />}
            </Button>
          </div>
        </div>

        {/* Mobile menu */}
        {mobileMenuOpen && (
          <div className="sm:hidden bg-gray-900/95 border-t border-gray-800 py-4">
            <div className="flex flex-col space-y-4 px-4">
              <Link
                to="/docs"
                className="text-blue-300 hover:text-white font-medium transition-colors py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Docs
              </Link>
              <Link
                to="/investor"
                className="text-blue-300 hover:text-white font-medium transition-colors py-2"
                onClick={() => setMobileMenuOpen(false)}
              >
                Investor Portal
              </Link>
              <Link
                to="/auth"
                onClick={() => {
                  console.log("Mobile login button clicked")
                  setMobileMenuOpen(false)
                }}
              >
                <Button variant="outline" className="w-full rounded-md border-gray-700 bg-blue-900/30 text-blue-300 hover:bg-blue-800/50 hover:text-white font-medium">
                  Login
                </Button>
              </Link>
            </div>
          </div>
        )}
      </div>
    </header>
  )
}
